import { ComboboxExternal, ComboboxItem } from '@round/creatorbase-ui';
import { countryOptions } from '../../../../../utility/constants';
import styles from './LocationExternalFilter.module.css';

export type LocationItem = ComboboxItem<string>;

type Props = {
    value: LocationItem[];
    onChange: (value: LocationItem[]) => void;
};

function LocationListItem(item: LocationItem) {
    const code = item.value?.toLowerCase() ?? '';
    return (
        <span className={styles.row}>
            <span className={`fi fi-${code} ${styles.flag}`} aria-hidden />
            <span className={styles.label}>{item.label}</span>
        </span>
    );
}

export const LocationExternalFilter = ({ value, onChange }: Props) => {
    return (
        <ComboboxExternal
            multiple
            autoHighlight
            items={countryOptions}
            isItemEqualToValue={(a, b) => a.value === b.value}
            value={value}
            onValueChange={onChange}
            placeholder="Search locations…"
            noItemsFound="No locations found"
            isClearable
            renderItem={LocationListItem}
        />
    );
};
